/*
adityaa 09/26/2022 3075154998 Changed DM label to Data mananger
dilip 10/04/2022 3075154998 Datamanager- tabs name changed,in filter changed payload and api
dilip 10/04/2022 3075154998 datamanager tabs name changed
Akhila  10/28/2022 3075154998 data manager ux changes
*/

import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import DataManager from './DataManagerTab';
import DataManagerFilter from './DataManagerFilter/index';
import DmRecordsSubTabs from './DmRecords';
import DMRecordGroup from './DMRecordGroup';
import MatchingLogic from './MatchingLogic';
import DataManagerFilterGroup from './DataManagerFilterGroup';


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  padding: {
    padding: theme.spacing(3),
  },
  demo1: {
    backgroundColor: '#296bff',
    color: 'white',
    borderRadius: '6px',
  },
}));

export default function EnableFrameworkTabs({value, setValue}) {
  const classes = useStyles();
  return (
    <div className={classes.root}>

      <div className={classes.subContent}>
        {value === 0 && <DataManager />}
        {value === 1 && <DmRecordsSubTabs/>}
        {value === 2 && <DMRecordGroup/>}
        {value === 3 && <DataManagerFilter/>}
        {value === 4 && <DataManagerFilterGroup/>}
        {value === 5 && <MatchingLogic/>}
        {/* {value === 3 && <EnableFileFormat />} */}
      </div>
    </div>
  );
}
